// CountryFlagDropdown.tsx
import React from 'react';
import { MenuItem, Stack } from '@mui/material';
import { RHFSelect } from '@raas/shared/src/components/minimals/hook-form';
// prettier-ignore
import {
    AC, AD, AE, AF, AG, AI, AL, AM, AO, AQ, AR, AS, AT, AU, AW, AX, AZ, BA, BB, BD, BE, BF, BG, BH, BI, BJ, BL, BM, BN, BO, BQ, BR, BS, BT, BV, BW, BY, BZ, CA, CC, CD, CF, CG, CH, CI, CK, CL, CM, CN, CO, CR,
    CU, CV, CW, CX, CY, CZ, DE, DJ, DK, DM, DO, DZ, EC, EE, EG, EH, ER, ES, ET, EU, FI, FJ, FK, FM, FO, FR, GA, GB, GD, GE, GF, GG, GH, GI, GL, GM, GN, GP, GQ, GR, GS, GT, GU, GW, GY, HK, HM, HN, HR, HT, HU,
    IC, ID, IE, IL, IM, IN, IO, IQ, IR, IS, IT, JE, JM, JO, JP, KE, KG, KH, KI, KM, KN, KP, KR, KW, KY, KZ, LA, LB, LC, LI, LK, LR, LS, LT, LU, LV, LY, MA, MC, MD, ME, MF, MG, MH, MK, ML, MM, MN, MO, MP, MQ,
    MR, MS, MT, MU, MV, MW, MX, MY, MZ, NA, NC, NE, NF, NG, NI, NL, NO, NP, NR, NU, NZ, OM, PA, PE, PF, PG, PH, PK, PL, PM, PN, PR, PS, PT, PW, PY, QA, RE, RO, RS, RU, RW, SA, SB, SC, SD, SE, SG, SH, SI, SJ,
    SK, SL, SM, SN, SO, SR, SS, ST, SV, SX, SY, SZ, TA, TC, TD, TF, TG, TH, TJ, TK, TL, TM, TN, TO, TR, TT, TV, TW, TZ, UA, UG, UM, UY, UZ, VA, VC, VE, VG, VI, VN, VU, WF, WS, XK, YE, YT, ZA, ZM, ZW
} from 'country-flag-icons/react/3x2';
import { countries } from './CountriesArray';
import { UneceFlag } from './UNFlag';
import { USFlag } from './USFlag';
import { ISOFlag } from './ISOFlag';
import { EuroNCAPFlag } from './EuroNCAPFlag';
import { NATOFlag } from './NATOFlag';
import { KontrolLogo } from './KontrolLogo';

interface CountryFlagDropdownProps {
  name: string;
  label: string;
  disabled: boolean;
  sx?: React.CSSProperties;
}

const CountryFlagDropdown: React.FC<CountryFlagDropdownProps> = ({ name, label, disabled, sx }) => (
  <RHFSelect
    name={name}
    label={label}
    InputLabelProps={{ shrink: true }}
    disabled={disabled}
    sx={sx}
  >
    {countries.map((country) => (
      <MenuItem key={country.code} value={country.code}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {getCountryFlag(country.code, { width: '30px', height: 'auto', marginRight: '4px' })}
          {country.label}
        </Stack>
      </MenuItem>
    ))}
  </RHFSelect>
);

export const getCountryFlag = (
  code: string,
  styles?: React.CSSProperties,
  flagsWithoutWrapper?: boolean
) => {
  switch (code) {
    case 'UN':
      return flagsWithoutWrapper ? (
        <div style={{ height: '75px' }}>
          <UneceFlag styles={styles} />
        </div>
      ) : (
        <UneceFlag styles={styles} />
      );
    case 'AC':
      return <AC style={styles} />;
    case 'AD':
      return <AD style={styles} />;
    case 'AE':
      return <AE style={styles} />;
    case 'AF':
      return <AF style={styles} />;
    case 'AG':
      return <AG style={styles} />;
    case 'AI':
      return <AI style={styles} />;
    case 'AL':
      return <AL style={styles} />;
    case 'AM':
      return <AM style={styles} />;
    case 'AO':
      return <AO style={styles} />;
    case 'AQ':
      return <AQ style={styles} />;
    case 'AR':
      return <AR style={styles} />;
    case 'AS':
      return <AS style={styles} />;
    case 'AT':
      return <AT style={styles} />;
    case 'AU':
      return <AU style={styles} />;
    case 'AW':
      return <AW style={styles} />;
    case 'AX':
      return <AX style={styles} />;
    case 'AZ':
      return <AZ style={styles} />;
    case 'BA':
      return <BA style={styles} />;
    case 'BB':
      return <BB style={styles} />;
    case 'BD':
      return <BD style={styles} />;
    case 'BE':
      return <BE style={styles} />;
    case 'BF':
      return <BF style={styles} />;
    case 'BG':
      return <BG style={styles} />;
    case 'BH':
      return <BH style={styles} />;
    case 'BI':
      return <BI style={styles} />;
    case 'BJ':
      return <BJ style={styles} />;
    case 'BL':
      return <BL style={styles} />;
    case 'BM':
      return <BM style={styles} />;
    case 'BN':
      return <BN style={styles} />;
    case 'BO':
      return <BO style={styles} />;
    case 'BQ':
      return <BQ style={styles} />;
    case 'BR':
      return <BR style={styles} />;
    case 'BS':
      return <BS style={styles} />;
    case 'BT':
      return <BT style={styles} />;
    case 'BV':
      return <BV style={styles} />;
    case 'BW':
      return <BW style={styles} />;
    case 'BY':
      return <BY style={styles} />;
    case 'BZ':
      return <BZ style={styles} />;
    case 'CA':
      return <CA style={styles} />;
    case 'CC':
      return <CC style={styles} />;
    case 'CD':
      return <CD style={styles} />;
    case 'CF':
      return <CF style={styles} />;
    case 'CG':
      return <CG style={styles} />;
    case 'CH':
      return <CH style={styles} />;
    case 'CI':
      return <CI style={styles} />;
    case 'CK':
      return <CK style={styles} />;
    case 'CL':
      return <CL style={styles} />;
    case 'CM':
      return <CM style={styles} />;
    case 'CN':
      return <CN style={styles} />;
    case 'CO':
      return <CO style={styles} />;
    case 'CR':
      return <CR style={styles} />;
    case 'CU':
      return <CU style={styles} />;
    case 'CV':
      return <CV style={styles} />;
    case 'CW':
      return <CW style={styles} />;
    case 'CX':
      return <CX style={styles} />;
    case 'CY':
      return <CY style={styles} />;
    case 'CZ':
      return <CZ style={styles} />;
    case 'DE':
      return <DE style={styles} />;
    case 'DJ':
      return <DJ style={styles} />;
    case 'DK':
      return <DK style={styles} />;
    case 'DM':
      return <DM style={styles} />;
    case 'DO':
      return <DO style={styles} />;
    case 'DZ':
      return <DZ style={styles} />;
    case 'EC':
      return <EC style={styles} />;
    case 'EE':
      return <EE style={styles} />;
    case 'EG':
      return <EG style={styles} />;
    case 'EH':
      return <EH style={styles} />;
    case 'ER':
      return <ER style={styles} />;
    case 'ES':
      return <ES style={styles} />;
    case 'ET':
      return <ET style={styles} />;
    case 'EU':
      return <EU style={styles} />;
    case 'EuroNCAP':
      return flagsWithoutWrapper ? (
        <div style={{ height: '75px' }}>
          <EuroNCAPFlag styles={styles} />
        </div>
      ) : (
        <EuroNCAPFlag styles={styles} />
      );
    case 'FI':
      return <FI style={styles} />;
    case 'FJ':
      return <FJ style={styles} />;
    case 'FK':
      return <FK style={styles} />;
    case 'FM':
      return <FM style={styles} />;
    case 'FO':
      return <FO style={styles} />;
    case 'FR':
      return <FR style={styles} />;
    case 'GA':
      return <GA style={styles} />;
    case 'GB':
      return <GB style={styles} />;
    case 'GD':
      return <GD style={styles} />;
    case 'GE':
      return <GE style={styles} />;
    case 'GF':
      return <GF style={styles} />;
    case 'GG':
      return <GG style={styles} />;
    case 'GH':
      return <GH style={styles} />;
    case 'GI':
      return <GI style={styles} />;
    case 'GL':
      return <GL style={styles} />;
    case 'GM':
      return <GM style={styles} />;
    case 'GN':
      return <GN style={styles} />;
    case 'GP':
      return <GP style={styles} />;
    case 'GQ':
      return <GQ style={styles} />;
    case 'GR':
      return <GR style={styles} />;
    case 'GS':
      return <GS style={styles} />;
    case 'GT':
      return <GT style={styles} />;
    case 'GU':
      return <GU style={styles} />;
    case 'GW':
      return <GW style={styles} />;
    case 'GY':
      return <GY style={styles} />;
    case 'HK':
      return <HK style={styles} />;
    case 'HM':
      return <HM style={styles} />;
    case 'HN':
      return <HN style={styles} />;
    case 'HR':
      return <HR style={styles} />;
    case 'HT':
      return <HT style={styles} />;
    case 'HU':
      return <HU style={styles} />;
    case 'IC':
      return <IC style={styles} />;
    case 'ID':
      return <ID style={styles} />;
    case 'IE':
      return <IE style={styles} />;
    case 'IL':
      return <IL style={styles} />;
    case 'IM':
      return <IM style={styles} />;
    case 'IN':
      return <IN style={styles} />;
    case 'IO':
      return <IO style={styles} />;
    case 'IQ':
      return <IQ style={styles} />;
    case 'IR':
      return <IR style={styles} />;
    case 'IS':
      return <IS style={styles} />;
    case 'ISO':
      return flagsWithoutWrapper ? (
        <div style={{ height: '75px' }}>
          <ISOFlag styles={styles} />
        </div>
      ) : (
        <ISOFlag styles={styles} />
      );
    case 'IT':
      return <IT style={styles} />;
    case 'JE':
      return <JE style={styles} />;
    case 'JM':
      return <JM style={styles} />;
    case 'JO':
      return <JO style={styles} />;
    case 'JP':
      return <JP style={styles} />;
    case 'KE':
      return <KE style={styles} />;
    case 'KG':
      return <KG style={styles} />;
    case 'KH':
      return <KH style={styles} />;
    case 'KI':
      return <KI style={styles} />;
    case 'KM':
      return <KM style={styles} />;
    case 'KN':
      return <KN style={styles} />;
    case 'KP':
      return <KP style={styles} />;
    case 'KR':
      return <KR style={styles} />;
    case 'KW':
      return <KW style={styles} />;
    case 'KY':
      return <KY style={styles} />;
    case 'KZ':
      return <KZ style={styles} />;
    case 'LA':
      return <LA style={styles} />;
    case 'LB':
      return <LB style={styles} />;
    case 'LC':
      return <LC style={styles} />;
    case 'LI':
      return <LI style={styles} />;
    case 'LK':
      return <LK style={styles} />;
    case 'LR':
      return <LR style={styles} />;
    case 'LS':
      return <LS style={styles} />;
    case 'LT':
      return <LT style={styles} />;
    case 'LU':
      return <LU style={styles} />;
    case 'LV':
      return <LV style={styles} />;
    case 'LY':
      return <LY style={styles} />;
    case 'MA':
      return <MA style={styles} />;
    case 'MC':
      return <MC style={styles} />;
    case 'MD':
      return <MD style={styles} />;
    case 'ME':
      return <ME style={styles} />;
    case 'MF':
      return <MF style={styles} />;
    case 'MG':
      return <MG style={styles} />;
    case 'MH':
      return <MH style={styles} />;
    case 'MK':
      return <MK style={styles} />;
    case 'ML':
      return <ML style={styles} />;
    case 'MM':
      return <MM style={styles} />;
    case 'MN':
      return <MN style={styles} />;
    case 'MO':
      return <MO style={styles} />;
    case 'MP':
      return <MP style={styles} />;
    case 'MQ':
      return <MQ style={styles} />;
    case 'MR':
      return <MR style={styles} />;
    case 'MS':
      return <MS style={styles} />;
    case 'MT':
      return <MT style={styles} />;
    case 'MU':
      return <MU style={styles} />;
    case 'MV':
      return <MV style={styles} />;
    case 'MW':
      return <MW style={styles} />;
    case 'MX':
      return <MX style={styles} />;
    case 'MY':
      return <MY style={styles} />;
    case 'MZ':
      return <MZ style={styles} />;
    case 'NA':
      return <NA style={styles} />;
    case 'NATO':
      return flagsWithoutWrapper ? (
        <div style={{ height: '75px' }}>
          <NATOFlag styles={styles} />
        </div>
      ) : (
        <NATOFlag styles={styles} />
      );
    case 'NC':
      return <NC style={styles} />;
    case 'NE':
      return <NE style={styles} />;
    case 'NF':
      return <NF style={styles} />;
    case 'NG':
      return <NG style={styles} />;
    case 'NI':
      return <NI style={styles} />;
    case 'NL':
      return <NL style={styles} />;
    case 'NO':
      return <NO style={styles} />;
    case 'NP':
      return <NP style={styles} />;
    case 'NR':
      return <NR style={styles} />;
    case 'NU':
      return <NU style={styles} />;
    case 'NZ':
      return <NZ style={styles} />;
    case 'OM':
      return <OM style={styles} />;
    case 'PA':
      return <PA style={styles} />;
    case 'PE':
      return <PE style={styles} />;
    case 'PF':
      return <PF style={styles} />;
    case 'PG':
      return <PG style={styles} />;
    case 'PH':
      return <PH style={styles} />;
    case 'PK':
      return <PK style={styles} />;
    case 'PL':
      return <PL style={styles} />;
    case 'PM':
      return <PM style={styles} />;
    case 'PN':
      return <PN style={styles} />;
    case 'PR':
      return <PR style={styles} />;
    case 'PS':
      return <PS style={styles} />;
    case 'PT':
      return <PT style={styles} />;
    case 'PW':
      return <PW style={styles} />;
    case 'PY':
      return <PY style={styles} />;
    case 'QA':
      return <QA style={styles} />;
    case 'RE':
      return <RE style={styles} />;
    case 'RO':
      return <RO style={styles} />;
    case 'RS':
      return <RS style={styles} />;
    case 'RU':
      return <RU style={styles} />;
    case 'RW':
      return <RW style={styles} />;
    case 'SA':
      return <SA style={styles} />;
    case 'SB':
      return <SB style={styles} />;
    case 'SC':
      return <SC style={styles} />;
    case 'SD':
      return <SD style={styles} />;
    case 'SE':
      return <SE style={styles} />;
    case 'SG':
      return <SG style={styles} />;
    case 'SH':
      return <SH style={styles} />;
    case 'SI':
      return <SI style={styles} />;
    case 'SJ':
      return <SJ style={styles} />;
    case 'SK':
      return <SK style={styles} />;
    case 'SL':
      return <SL style={styles} />;
    case 'SM':
      return <SM style={styles} />;
    case 'SN':
      return <SN style={styles} />;
    case 'SO':
      return <SO style={styles} />;
    case 'SR':
      return <SR style={styles} />;
    case 'SS':
      return <SS style={styles} />;
    case 'ST':
      return <ST style={styles} />;
    case 'SV':
      return <SV style={styles} />;
    case 'SX':
      return <SX style={styles} />;
    case 'SY':
      return <SY style={styles} />;
    case 'SZ':
      return <SZ style={styles} />;
    case 'TA':
      return <TA style={styles} />;
    case 'TC':
      return <TC style={styles} />;
    case 'TD':
      return <TD style={styles} />;
    case 'TF':
      return <TF style={styles} />;
    case 'TG':
      return <TG style={styles} />;
    case 'TH':
      return <TH style={styles} />;
    case 'TJ':
      return <TJ style={styles} />;
    case 'TK':
      return <TK style={styles} />;
    case 'TL':
      return <TL style={styles} />;
    case 'TM':
      return <TM style={styles} />;
    case 'TN':
      return <TN style={styles} />;
    case 'TO':
      return <TO style={styles} />;
    case 'TR':
      return <TR style={styles} />;
    case 'TT':
      return <TT style={styles} />;
    case 'TV':
      return <TV style={styles} />;
    case 'TW':
      return <TW style={styles} />;
    case 'TZ':
      return <TZ style={styles} />;
    case 'UA':
      return <UA style={styles} />;
    case 'UG':
      return <UG style={styles} />;
    case 'UM':
      return <UM style={styles} />;
    case 'US':
      return flagsWithoutWrapper ? (
        <div style={{ height: '75px' }}>
          <USFlag styles={styles} />
        </div>
      ) : (
        <USFlag styles={styles} />
      );
    case 'UY':
      return <UY style={styles} />;
    case 'UZ':
      return <UZ style={styles} />;
    case 'VA':
      return <VA style={styles} />;
    case 'VC':
      return <VC style={styles} />;
    case 'VE':
      return <VE style={styles} />;
    case 'VG':
      return <VG style={styles} />;
    case 'VI':
      return <VI style={styles} />;
    case 'VN':
      return <VN style={styles} />;
    case 'VU':
      return <VU style={styles} />;
    case 'WF':
      return <WF style={styles} />;
    case 'WS':
      return <WS style={styles} />;
    case 'XK':
      return <XK style={styles} />;
    case 'YE':
      return <YE style={styles} />;
    case 'YT':
      return <YT style={styles} />;
    case 'ZA':
      return <ZA style={styles} />;
    case 'ZM':
      return <ZM style={styles} />;
    case 'ZW':
      return <ZW style={styles} />;
    default:
      return <KontrolLogo styles={styles} />;
  }
};

export default CountryFlagDropdown;
